







































































































































import _ from 'lodash';
import axios from 'axios';

import {
  Component,
  Mixins, Prop, Watch,
} from 'vue-property-decorator';

import {
  like, and,
} from '@/classes/pimcore-filtering/Filters';
import FilterBuilder from '@/classes/pimcore-filtering/FilterBuilder';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';

import { ratesEndpoints } from '@/utils/config';

import EntityCrud from '@/classes/EntityCrud';
import { CrudOperation } from '@/types/CrudOperation';
import ObjectFieldNormalizer from '@/classes/normalizers/field-normalizers/ObjectFieldNormalizer';
import { FetchPolicy } from 'apollo-client/core/watchQueryOptions';

import {
  WorkTypeModel,
  defaultWorkType,
  defaultTable,
  buildSupplierFingerprints,
  hasDuplicateSheets,
  normalizeSupplierIds,
  SheetModel,
} from '@/components/RatesPage/types';
import { sheetGridMessage } from '@/components/RatesPage/sheetGrid';
import EntityFilter from '@/components/Entity/EntityFilter.vue';
import CustomSelect from '@/components/FormBuilder/CustomSelect.vue';
import WorkTypeItem from '@/components/RatesPage/WorkTypeItem.vue';
import {
  RatesFilter,
  parseRatesFilter,
  ratesFilterEquals,
  serializeRatesFilter,
} from '@/utils/ratesFilterQuery';

@Component({
  components: {
    EntityFilter,
    CustomSelect,
    WorkTypeItem,
  },
})
export default class RatesPage extends Mixins(EntityHelperMixin) {
  @Prop({
    type: String,
    required: false,
    default: 'Rates',
  }) readonly localStoragePrefix!: string

  workTypes: Array<WorkTypeModel> = [];

  workTypesLoading = false;

  workTypesTemp: Array<WorkTypeModel> = [_.cloneDeep(defaultWorkType)];

  entityCrud: EntityCrud = new EntityCrud('Work', this.$apollo);

  objectFieldNormalizer = new ObjectFieldNormalizer();

  filters: Record<string, string> = {
    platform: '',
    client: '',
    supplier: '',
    workType: '',
  };

  loadedFilterCount = 0;

  initialized = false;

  /** Начальные значения фильтров из URL (приоритетнее localStorage). */
  routePlatform = '';

  routeClient = '';

  routeSupplier = '';

  /** Счётчики перекрытий: по всей базе, пока не выбраны площадка и клиент. */
  conflictCounters: { dead: number; partial: number; gap: number } | null = null;

  /** Доп. поля для запроса клиентов — связи с платформами (F-Q6). */
  clientExtraFields: Record<string, any> = { Plants: { id: '' } };

  /** Бамп токена → сброс клиента при смене платформы (F-Q6). */
  clientResetToken = 0;

  /** Карта dirty по WT (id/tempId → есть несохранённые правки). */
  dirtyMap: Record<string, boolean> = {};

  dirtyFilterHint = 'Фильтры нельзя менять, так как есть несохранённые данные. '
    + 'Сохраните данные или обновите страницу, чтобы сбросить изменения.';

  // true, пока оба фильтра не прошли первичную гидратацию (чтобы не сбрасывать клиента при загрузке).
  private ratesHydrating = true;

  beforeMount() {
    this.workTypesTemp = [];
  }

  created() {
    const routeFilter = parseRatesFilter(this.$route.query);
    this.routePlatform = routeFilter.platform;
    this.routeClient = routeFilter.client;
    this.routeSupplier = routeFilter.supplier;
    this.filters.workType = routeFilter.workType;
    this.loadConflictCounters();
  }

  /**
   * `created()` читает query один раз, поэтому переход на ту же страницу с другими
   * параметрами (из списка перекрытий) сам по себе фильтр не сменит — нужен watcher.
   * При несохранённых правках переход отклоняется: молча подменить фильтр значило бы
   * потерять правки, а сделать вид, что перешли, — обмануть (задача 10577).
   */
  @Watch('$route.query')
  onRouteQueryChange(next: Record<string, any>) {
    const incoming = parseRatesFilter(next);
    const current = parseRatesFilter(this.currentQuery());
    if (ratesFilterEquals(incoming, current)) {
      return;
    }
    if (this.hasUnsavedRatesChanges) {
      this.$bus.$emit('notification', this.dirtyFilterHint, 'warning');
      this.syncRatesQueryParams();
      return;
    }
    this.routePlatform = incoming.platform;
    this.routeClient = incoming.client;
    this.routeSupplier = incoming.supplier;
    this.filters.platform = incoming.platform;
    this.filters.client = incoming.client;
    this.filters.supplier = incoming.supplier;
    this.filters.workType = incoming.workType;
    this.workTypes = [];
    this.dirtyMap = {};
    if (this.searchAllowed) {
      this.searchWorkTypes('network-only');
    }
  }

  currentQuery(): Record<string, string> {
    return {
      platform: this.filters.platform,
      client: this.filters.client,
      supplier: this.filters.supplier,
      workType: this.filters.workType,
    };
  }

  filterLoaded() {
    this.loadedFilterCount += 1;

    // Площадка, клиент и поставщик — три EntityFilter'а: гидратация закончена, когда
    // отчитались все три, иначе URL зафиксируется без ещё не подставленного значения.
    if (this.loadedFilterCount >= 3) {
      // Гидратация завершена: фиксируем URL из текущих фильтров (если URL был пуст —
      // заполнится значениями из localStorage). Автозагрузки WT нет (F-Q3).
      this.ratesHydrating = false;
      this.initialized = true;
      this.syncRatesQueryParams();
    }
  }

  get searchAllowed() {
    const {
      platform,
      client,
    } = this.filters;
    return !!(platform && client);
  }

  get hasUnsavedRatesChanges(): boolean {
    if (this.workTypesTemp.length > 0) {
      return true;
    }
    return Object.values(this.dirtyMap).some(Boolean);
  }

  onDirtyChange(payload: { key: string | number; dirty: boolean }) {
    if (payload?.key == null) {
      return;
    }
    this.$set(this.dirtyMap, String(payload.key), !!payload.dirty);
  }

  applyFilter() {
    if (!this.searchAllowed || this.hasUnsavedRatesChanges) {
      return;
    }
    this.searchWorkTypes('network-only');
  }

  syncRatesQueryParams() {
    const query = serializeRatesFilter(
      this.currentQuery() as Partial<RatesFilter>,
      { ...this.$route.query },
    );
    if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
      this.$router.replace({ query }).catch(() => {
        // Vue Router rejects duplicate navigation; ignore when query is already in sync.
      });
    }
  }

  /** Виды работ, попавшие под сужающие фильтры поставщика и вида работ (считаем на клиенте). */
  get visibleWorkTypes(): Array<WorkTypeModel> {
    const all = [...this.workTypesTemp, ...this.workTypes];
    const supplierId = Number(this.filters.supplier);
    const workTypeId = this.filters.workType;

    return all.filter((workType) => {
      if (workTypeId && String(workType.id) !== String(workTypeId)) {
        return false;
      }
      if (!supplierId) {
        return true;
      }
      // Новый (ещё не сохранённый) вид работ прячем только фильтром по виду работ.
      if (!workType.id) {
        return true;
      }
      return (workType.sheets || []).some((sheet) => normalizeSupplierIds(
        sheet.suppliers as unknown[],
      ).includes(supplierId));
    });
  }

  get workTypeFilterItems() {
    return this.workTypes
      .filter((workType) => !!workType.id)
      .map((workType) => ({ text: workType.name || String(workType.id), value: String(workType.id) }))
      .sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }));
  }

  get conflictCountersLabel(): string {
    const counters = this.conflictCounters;
    if (!counters) {
      return '';
    }
    const parts = [`🔴 ${counters.dead}`, `🟠 ${counters.partial}`, `🔵 ${counters.gap}`];
    return parts.join(' · ');
  }

  get conflictsRoute() {
    return {
      name: 'RatesConflictsPage',
      query: serializeRatesFilter(this.currentQuery() as Partial<RatesFilter>),
    };
  }

  /**
   * Счётчик следует фильтру: пока площадка и клиент не выбраны — по всей базе, дальше по
   * загруженным видам работ. Площадки и клиента у `stg_work` нет (их знает Pimcore),
   * поэтому сужение уходит списком id, а не отдельным параметром.
   */
  async loadConflictCounters() {
    try {
      const params = new URLSearchParams();
      params.append('limit', '1');
      const ids = this.workTypes.map((workType) => String(workType.id)).filter(Boolean);
      if (ids.length) {
        params.append('work_type_id', ids.join(','));
      }
      const resp = await axios.get(ratesEndpoints.conflicts, { params });
      const counters = resp?.data?.data?.counters || resp?.data?.counters;
      if (!counters) {
        this.conflictCounters = null;
        return;
      }
      this.conflictCounters = {
        dead: Number(counters.with_dead || 0),
        partial: Number(counters.with_partial || 0),
        gap: Number(counters.with_gap || 0),
      };
    } catch (e) {
      // Список перекрытий — подсказка, а не условие работы страницы: молча без счётчика.
      this.conflictCounters = null;
    }
  }

  supplierFingerprints(sheets: Array<SheetModel> | null | undefined): Record<string, number[]> {
    return buildSupplierFingerprints(sheets);
  }

  extractAxiosErrorMessage(error: unknown): string {
    const err = error as { response?: { data?: unknown }; message?: string };
    if (err.response && err.response.data !== undefined) {
      const { data } = err.response;
      if (typeof data === 'string') {
        return data;
      }
      if (data && typeof data === 'object') {
        const payload = data as Record<string, unknown>;
        if (payload.message != null) {
          return String(payload.message);
        }
        // work-calc отвечает `{statusCode, error: {type, description}}`; текст для пользователя
        // лежит в description, а String() на объекте выдавал бы «[object Object]».
        if (payload.error != null && typeof payload.error === 'object') {
          const inner = payload.error as Record<string, unknown>;
          if (inner.description != null) {
            return String(inner.description);
          }
          if (inner.message != null) {
            return String(inner.message);
          }
        }
        if (payload.error != null) {
          return String(payload.error);
        }
      }
    }
    if (error instanceof Error) {
      // Отказ Pimcore (например, дубль названия вида работ) Apollo отдаёт с приставкой.
      return error.message.replace(/^GraphQL error: /, '');
    }
    if (err.message) {
      return err.message;
    }
    return String(error);
  }

  parseMartRefreshPayload(responseRatesTable: any): {
    refreshedRows: number;
    totalRows: number;
    partial: boolean;
  } | null {
    const payload = responseRatesTable?.data?.data || responseRatesTable?.data;
    if (!payload || typeof payload !== 'object') {
      return null;
    }
    const data = payload as Record<string, unknown>;
    if (
      data.mart_refreshed_rows == null
      && data.mart_total_rows == null
      && data.mart_refresh_partial == null
    ) {
      return null;
    }

    const refreshedRows = Number(data.mart_refreshed_rows ?? 0);
    const totalRows = Number(data.mart_total_rows ?? refreshedRows);
    const partial = Boolean(data.mart_refresh_partial);

    return {
      refreshedRows: Number.isFinite(refreshedRows) ? refreshedRows : 0,
      totalRows: Number.isFinite(totalRows) ? totalRows : 0,
      partial,
    };
  }

  isTimeoutLikeError(error: unknown): boolean {
    const err = error as {
      response?: { status?: number };
      code?: string;
      message?: string;
    };
    if (err.response?.status === 504) {
      return true;
    }
    if (err.code === 'ECONNABORTED') {
      return true;
    }
    return /timeout|timed out/i.test(err.message || '');
  }

  async searchWorkTypes(fetchPolicy: FetchPolicy = 'cache-first') {
    const {
      platform,
      client,
    } = this.filters;
    if (!this.searchAllowed) {
      this.workTypes = [];
      return;
    }
    // свежая загрузка списка — снимаем флаги dirty.
    this.dirtyMap = {};
    this.workTypesLoading = true;
    const workTypes = await this.loadWorkTypes(platform, client, fetchPolicy);

    if (workTypes?.length) {
      /** TODO [m.kudryashov 15.04.2023 - 12:20]:
      * переименовать loadRatesTables, потому что теперь возвращает не только таблицы рейтов
      */
      const allWorkRates = await this.loadRatesTables(workTypes.map((v: WorkTypeModel) => v.id.toString()));
      this.workTypes = workTypes.map((v: any) => {
        // все рейты работ по текущему, итерируемому типу работы
        let workRates = allWorkRates.find((v_rt: any) => v_rt.workTypeId.toString() === v.id.toString());
        const isSheetsEmpty = !workRates?.sheets?.length;
        if (isSheetsEmpty) {
          workRates = {
            sheets: [{
              cells: _.cloneDeep(defaultTable),
              key: Math.random().toString().substring(2),
              suppliers: [],
            }],
          };
        }

        const sheets = (workRates.sheets || []).map((sheet: SheetModel) => ({
          ...sheet,
          suppliers: normalizeSupplierIds(sheet.suppliers as unknown[]),
        }));

        return {
          ...v,
          rateTableCreated: !isSheetsEmpty,
          sheets,
        };
      });
    } else {
      this.workTypes = [];
    }
    this.workTypesLoading = false;
    this.loadConflictCounters();
  }

  // plan-b-prime V3: after an update, reload rates for the saved work type only, instead of
  // re-fetching the whole list. Avoids unrelated panels "jumping"/collapsing and keeps the
  // user's context on the sheet they just edited.
  async refreshWorkTypeRates(workTypeId: string | number) {
    const allWorkRates = await this.loadRatesTables([workTypeId.toString()]);
    const workRates = allWorkRates.find(
      (v: any) => v.workTypeId.toString() === workTypeId.toString(),
    );
    const idx = this.workTypes.findIndex(
      (v: WorkTypeModel) => v.id?.toString() === workTypeId.toString(),
    );
    if (idx === -1) {
      await this.searchWorkTypes('network-only');
      return;
    }

    const isSheetsEmpty = !workRates?.sheets?.length;
    const sheets = isSheetsEmpty
      ? [{
        cells: _.cloneDeep(defaultTable),
        key: Math.random().toString().substring(2),
        suppliers: [],
      }]
      : (workRates.sheets || []).map((sheet: SheetModel) => ({
        ...sheet,
        suppliers: normalizeSupplierIds(sheet.suppliers as unknown[]),
      }));

    this.$set(this.workTypes, idx, {
      ...this.workTypes[idx],
      rateTableCreated: !isSheetsEmpty,
      sheets,
    });
  }

  async loadRatesTables(workTypesIds: Array<string>) {
    const params = new URLSearchParams();
    params.append('workTypeId', workTypesIds.join(','));
    const resp = await axios.get(ratesEndpoints.getRatesTables, {
      params,
    });

    return resp.data;
  }

  async loadWorkTypes(platform: string, client: string, fetchPolicy: FetchPolicy = 'cache-first') {
    const filterBuilder = new FilterBuilder();
    filterBuilder.addFilters(
      and(
        and(
          like('platform__id', platform),
        ),
        and(
          like('client__id', client),
        ),
      ),
    );
    return this.loadEntityListing('Work', {
      filter: filterBuilder.build(),
    }, fetchPolicy);
  }

  filterChange(name: string, value: string) {
    // dirty-lock: при несохранённых данных фильтры не меняются (§2.5).
    if (this.hasUnsavedRatesChanges) {
      return;
    }
    this.filters[name] = value || '';

    // Поставщик и вид работ только сужают уже загруженный список — перезапрашивать
    // виды работ незачем, и терять открытые панели пользователю тем более незачем.
    if (name === 'supplier' || name === 'workType') {
      this.syncRatesQueryParams();
      return;
    }

    this.workTypesTemp = [];

    if (name === 'platform' && !this.ratesHydrating) {
      // F-Q6: смена платформы сбрасывает клиента.
      this.filters.client = '';
      this.clientResetToken += 1;
    }

    // §2.5: смена фильтра без dirty — сразу очистить контент страницы.
    this.workTypes = [];
    this.dirtyMap = {};
    this.workTypesLoading = false;

    // F-Q2: каждый ключ пишется в URL при изменении.
    this.syncRatesQueryParams();
  }

  addWorkType(): void {
    if (!this.searchAllowed) {
      return;
    }
    const {
      platform,
      client,
    } = this.filters;
    this.workTypesTemp.splice(0, 0, {
      ..._.cloneDeep(defaultWorkType),
      sheets: [{
        cells: _.cloneDeep(defaultTable),
        key: Math.random().toString().substring(2),
        suppliers: [],
      }],
      tempId: Date.now(),
      platform: {
        id: platform,
      },
      client: {
        id: client,
      },
    });
  }

  copyWorkType(workType: WorkTypeModel): void {
    const copy = _.cloneDeep(workType);
    delete copy.id;
    this.workTypesTemp.splice(0, 0, {
      ...copy,
      tempId: Date.now(),
    });
  }

  async workItemAction(action: CrudOperation, workType: WorkTypeModel) {
    const rateTable = workType.sheets;
    const {
      id,
      name,
      platform,
      client,
      cost_center,
      CostAccount,
      work_billing_type,
      units,
      standard,
    } = workType;
    const builtWorkType = {
      name: name.trim(),
      platform: this.objectFieldNormalizer.normalize(platform),
      client: this.objectFieldNormalizer.normalize(client),
      cost_center: this.objectFieldNormalizer.normalize(cost_center),
      CostAccount: this.objectFieldNormalizer.normalize(CostAccount),
      work_billing_type: this.objectFieldNormalizer.normalize(work_billing_type),
      units: this.objectFieldNormalizer.normalize(units),
      standard: standard || '',
    };
    let workTypeId = id;

    try {
      if (
        (action === CrudOperation.create || action === CrudOperation.update)
        && hasDuplicateSheets(rateTable)
      ) {
        this.$bus.$emit('notification', 'Удалите дубли листов перед сохранением', 'warning');
        return;
      }

      // work-calc такой лист тоже не сохранит (`TariffSheetGrid`), но шлюз `/services/rates`
      // тело его ответа не прокидывает — на 400 приходит `{"error": "400"}`. Поэтому текст
      // с конкретными полосами показывается здесь, до отправки.
      if (action === CrudOperation.create || action === CrudOperation.update) {
        const gridProblem = sheetGridMessage(rateTable);
        if (gridProblem) {
          this.$bus.$emit('notification', gridProblem, 'error');
          return;
        }
      }

      this.workTypesLoading = true;
      let responseWorkType: any = null;
      let responseRatesTable: any = null;
      if (action === CrudOperation.create) {
        responseWorkType = await this.entityCrud.create({
          input: builtWorkType,
          key: builtWorkType.name,
          folderPath: `/FMLHR/Виды работ/${platform?.name}/${client?.legal_name}`,
        });
        if (!responseWorkType?.success) {
          throw new Error(responseWorkType?.message || 'Ошибка создания. Проверьте наличие папок в PimCore -> Виды работ');
        }
        workTypeId = responseWorkType.message.split(': ')[1];
        responseRatesTable = await axios.post(ratesEndpoints.createRatesTable, {
          workTypeId,
          sheet: rateTable,
        });
        this.workTypesTemp = this.workTypesTemp.filter((v: WorkTypeModel) => v.tempId !== workType.tempId);
      }

      if (action === CrudOperation.update) {
        responseWorkType = await this.entityCrud.update(workTypeId, builtWorkType);
        responseRatesTable = await axios.put(ratesEndpoints.updateRatesTable, {
          workTypeId,
          sheet: rateTable,
        });
      }

      if (action === CrudOperation.delete) {
        if (!workTypeId) {
          this.workTypesTemp = this.workTypesTemp.filter((v: WorkTypeModel) => v.tempId !== workType.tempId);
          return;
        }
        responseWorkType = await this.entityCrud.delete(workTypeId);
        const params = new URLSearchParams();
        params.append('workTypeId', workTypeId.toString());
        await axios.delete(ratesEndpoints.deleteRatesTable, {
          params,
        });
      }
      if (action === CrudOperation.update && workTypeId) {
        await this.refreshWorkTypeRates(workTypeId);
      } else {
        await this.searchWorkTypes('network-only');
      }
      if (!responseWorkType || !responseWorkType.success) {
        throw new Error(responseWorkType?.message);
      }
      if (action === CrudOperation.create || action === CrudOperation.update) {
        const martRefresh = this.parseMartRefreshPayload(responseRatesTable);
        if (martRefresh?.partial) {
          this.$bus.$emit(
            'notification',
            this.$t('rates_save_mart_partial', {
              n: martRefresh.refreshedRows,
              total: martRefresh.totalRows,
            }) as string,
            'warning',
          );
        } else {
          this.$bus.$emit(
            'notification',
            this.$t('rates_save_mart_refreshed', {
              n: martRefresh?.refreshedRows ?? 0,
            }) as string,
            'success',
          );
        }
      }
      this.workTypesLoading = false;
    } catch (e) {
      if (
        (action === CrudOperation.create || action === CrudOperation.update)
        && this.isTimeoutLikeError(e)
      ) {
        this.$bus.$emit(
          'notification',
          this.$t('rates_save_timeout_maybe_applied') as string,
          'warning',
        );
        this.workTypesLoading = false;
        return;
      }
      const message = this.extractAxiosErrorMessage(e);
      if (message.includes('Duplicate sheets')) {
        this.$bus.$emit(
          'notification',
          'Лист с таким набором поставщиков уже существует. Удалите дубли перед сохранением.',
          'error',
        );
      } else {
        this.$bus.$emit('notification', `${action}, ${message}`, 'error');
      }
      this.workTypesLoading = false;
    }
  }
}

